const backdropInvert = {
    name: "backdrop-invert",
    path: "/backdrop-invert",
    title: "backdrop-invert",
    description: "Utilities for applying backdrop-invert filter effects to element's backdrop:",
    value: {
        'filter': {
            'backdrop-invert': 'invert(100%)',
            'backdrop-invert-<number>': 'invert(<number>%)'
        },
    },
    exampleData: [
        {
            "title": "backdrop-invert-50, backdrop-invert-100",
            "description": "to control an element's backdrop-invert:",
            "moreDescription": "",
            "parentClass": "grid md:grid-columns-3 gap-10 !bg-none !border-0 pt-10",
            "example": {
                "element": "img",
                "src": [
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-full mx-auto rounded-lg ",
                        "divClass": "absolute inset-10 bg-color-white/30 rounded-lg  backdrop-invert-0",
                        "text": "backdrop-invert-0",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-full mx-auto rounded-lg ",
                        "divClass": "absolute inset-10 bg-color-white/30 rounded-lg  backdrop-invert-25",
                        "text": "backdrop-invert-25",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-full mx-auto rounded-lg ",
                        "divClass": "absolute inset-10 bg-color-white/30 rounded-lg  backdrop-invert",
                        "text": "backdrop-invert",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                ],
                "className": "relative",
                "code": `<img class="backdrop-invert-0" src="/img/mountains.jpg" />
<img class="backdrop-invert-25" src="/img/mountains.jpg" />
<img class="backdrop-invert" src="/img/mountains.jpg" />`
            }
        }
    ]
};

export default backdropInvert;